import { useEffect } from 'react';

let openCount = 0;

export function setEmbeddedDialogOpen(open) {
  if (typeof window === 'undefined' || window.parent === window) return;
  openCount += open ? 1 : -1;
  if (openCount < 0) openCount = 0;
  window.parent.postMessage(
    { type: 'meetgeek-dialog', open: openCount > 0 },
    '*'
  );
}

export function useEmbeddedDialog(open) {
  useEffect(() => {
    if (!open) return undefined;
    setEmbeddedDialogOpen(true);
    return () => setEmbeddedDialogOpen(false);
  }, [open]);
}
